import { Box } from '@/components/Box/Box';
import { ProgressBar } from '@/components/ProgressBar/ProgressBar';
import { getMasterAdminBillingEventsPath } from '../../../_BillingEventsPage/path/path';
import { Button } from '@/components/Button/Button';
import { useSubscriptionStatus } from '@/bundle/shared/hooks/useSubscriptionStatus';
import { InternalOrganizationBillingDetailsType } from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { getBuyOverageWiresPath } from '@/bundle/_MasterAdmin/_BuyOverageWiresPage/path/path';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';

type PaymentsUsageRowType = {
  billingDetails: InternalOrganizationBillingDetailsType;
};

export const PaymentsUsageRow = ({ billingDetails }: PaymentsUsageRowType) => {
  const { navigateFrom } = useStatefulNavigation();
  const { isSuspendedSubscription } = useSubscriptionStatus();

  const { monthly_views_available, extra_views_available, current_plan, extra_views_bought } = billingDetails;
  const { monthly_views } = current_plan || {};
  const isAllLimitsReached = monthly_views_available === 0 && extra_views_available === 0 && extra_views_bought === 0;

  return (
    <Box width='100%' display='flex' alignItems='center' columnGap='16px'>
      <ProgressBar
        label='Sending and/or Receiving'
        count={monthly_views - monthly_views_available}
        totalCount={monthly_views}
        highlightOnComplete
      />
      <Box flexShrink={0}>
        {!isAllLimitsReached && (
          <Button
            variant='secondary'
            size='medium'
            onClick={() => navigateFrom(getMasterAdminBillingEventsPath())}
            mobileStretch
            width='110px'
          >
            View Details
          </Button>
        )}

        {isAllLimitsReached && (
          <Button
            size='medium'
            onClick={() => navigateFrom(getBuyOverageWiresPath())}
            mobileStretch
            width='110px'
            disabled={isSuspendedSubscription}
          >
            Buy More
          </Button>
        )}
      </Box>
    </Box>
  );
};
